import {ActionItemDto} from '@domain/pom'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {TasksApiPath} from '../../consts'

const QueryKey = 'get-action-items'

type Params = {
  plantId: string
  actionId: string
}

export const usePomAction = ({plantId, actionId}: Params) => {
  const path = `${TasksApiPath.POM_QUESTIONNARIES}/${plantId}/actions/${actionId}`

  return useQuery<ActionItemDto, AxiosError, ActionItemDto>({
    queryKey: [QueryKey, plantId, actionId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ActionItemDto>(path, {signal})

      return response.data
    }
  })
}
